import React from 'react';
import './upload-invoice.scss';
import { SVGS } from '../../assets';
import { FileUploadOutput } from '@zonofi/common/types/interface';

interface UploadProps {
  files: FileUploadOutput[];
  setShowUploadInvoiceDrawer: (val: boolean) => void;
}

export const UploadInvoice: React.FC<UploadProps> = ({
  files,
  setShowUploadInvoiceDrawer,
}) => {
  return (
    <div className="upload-invoice-container">
      <div className="upload-invoice-container-header">
        <span className="upload-invoice-container-header-text font-semibold">
          INVOICE DOCUMENT
        </span>
        <span className="upload-invoice-container-header-description font-regular">
          Upload your invoice receipts. We accept JPG, PDF, PNG upto 5MB{' '}
        </span>
      </div>
      <div className="upload-invoice-container-uploaded">
        <div
          className="upload-invoice-container-uploaded-area"
          onClick={async () => {
            setShowUploadInvoiceDrawer(true);
          }}
        >
          <div className="upload-invoice-container-uploaded-area-content">
            <div className="upload-invoice-container-uploaded-area-content-icon">
              <img
                src={SVGS.UploadFile}
                alt="upload-invoice-file-icon"
                width={24}
                height={24}
              />
            </div>
            <span className="upload-invoice-container-uploaded-area-content-text font-regular">
              Upload
            </span>
          </div>
        </div>
        {files && files?.length > 0 && (
          <div className="upload-invoice-container-uploaded-files">
            {files.map((file, index) => {
              return (
                <div
                  key={`${file?.name}-${index}`}
                  className="upload-invoice-container-uploaded-files-file"
                >
                  <div className="upload-invoice-container-uploaded-files-file-name">
                    <div className="upload-invoice-container-uploaded-files-file-name-icon">
                      <img
                        src={SVGS.FileUploadImg}
                        alt=""
                        width={16}
                        height={16}
                      />
                    </div>
                    <span className="upload-invoice-container-uploaded-files-file-name-text font-regular">
                      {file.name}
                    </span>
                  </div>
                  <div className="upload-invoice-container-uploaded-files-file-options">
                    <img src={SVGS.KebabMenu} alt="" width={16} height={16} />
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};
